export const SKILL_LIBRARY_SEGMENT = "/agent/skills";

export const SKILL_LIBRARY_PATH = `/settings${SKILL_LIBRARY_SEGMENT}`;
